import React from 'react';
import type { BudgetCategory } from '../../../data/mockData';
interface BudgetBreakdownProps {
  categories: BudgetCategory[];
}
export function BudgetBreakdown({
  categories
}: BudgetBreakdownProps) {
  return <div className="mt-3 space-y-2 bg-gray-50 dark:bg-dark-hover rounded-xl p-3" data-id="element-90">
      <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2" data-id="element-91">
        Budget Overview
      </p>
      {categories.map(cat => {
      const pct = Math.min(cat.spent / cat.limit * 100, 100);
      const isOver = cat.spent > cat.limit;
      const color = isOver ? '#EF4444' : pct > 80 ? '#F59E0B' : '#39E75F';
      return <div key={cat.id} data-id="element-92">
            <div className="flex justify-between items-center mb-1" data-id="element-93">
              <span className="text-xs text-gray-700 dark:text-gray-300 flex items-center gap-1" data-id="element-94">
                <span data-id="element-95">{cat.icon}</span> {cat.name}
              </span>
              <span className="text-xs font-medium" style={{
            color: isOver ? '#EF4444' : '#6B7280'
          }} data-id="element-96">
                ${cat.spent.toFixed(0)} / ${cat.limit}
              </span>
            </div>
            <div className="h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-97">
              <div className="h-full rounded-full transition-all duration-500" style={{
            width: `${pct}%`,
            backgroundColor: color
          }} data-id="element-98" />
            </div>
          </div>;
    })}
    </div>;
}